import React, { useState } from "react";
import Modal from "react-modal";
import { useHistory } from "react-router-dom";
import Index from "../about/index";

const heroContent = {
  heroImage: "img/hero/devendra.png",
  heroMobileImage: "img/hero/devendra_mobile.png",
  heroTitleName: "Devendra K",
  heroDesignation: "Full-Stack Developer",
  heroDescriptions: `Team Lead & Senior Full-Stack Developer with 9 years of experience specializing in scalable backend systems and
modern web architectures. Expert in Node.js, React JS, and Microservices, with a proven track record of designing
production-ready boilerplates and leading high-performing engineering teams. Deep experience in AWS (EC2, S3),
gRPC, and Docker. Currently expanding expertise in Generative AI and Python to build the next generation of AI-
driven applications`,
  heroBtn: "more about me",
};

const HeroLight = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className="row home-details-container align-items-center">
        <div
          className="col-lg-4 bg position-fixed d-none d-lg-block"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + "/" + heroContent.heroImage})`,
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        ></div>
        <div className="col-12 col-lg-8 offset-lg-4 home-details  text-center text-lg-start">
          <div>
            <img
              src={heroContent.heroMobileImage}
              className="img-fluid main-img-mobile d-sm-block d-lg-none"
              alt="Devendra Kumar Rajput - Full-Stack Developer Profile"
              loading="eager"
              fetchpriority="high"
              width="480"
              height="480"
            />
            <h1 className="text-uppercase poppins-font">
              I'm {heroContent.heroTitleName}.
              <span className="hero-designation">{heroContent.heroDesignation}</span>
            </h1>
            <p className="open-sans-font">{heroContent.heroDescriptions}</p>
            {/* <button className="button" onClick={toggleModalOne}>
              <span className="button-text">{heroContent.heroBtn}</span>
              <span className="button-icon fa fa-arrow-right"></span>
            </button> */}
            <button className="button" onClick={() => { return history.push('/about') }}>
              <span className="button-text">{heroContent.heroBtn}</span>
              <span className="button-icon fa fa-arrow-right"></span>
            </button>
          </div>
        </div>
      </div>
      {/* End home-details-container */}

      {/* Start Modal for About More */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark light"
        overlayClassName="custom-overlay"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src="/img/cancel.svg" alt="close icon" />
          </button>
          {/* End close icon */}

          <div className="box_inner about green">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  ABOUT <span>ME</span>
                </h1>
                <span className="title-bg">Resume</span>
              </div>
              {/* End title */}
              <Index />
            </div>
          </div>
        </div>
        {/* End modal box news */}
      </Modal>
      {/* End  Modal for About More */}
    </>
  );
};

export default HeroLight;
